import { createAsyncThunk } from '@reduxjs/toolkit';
import createNotification from '../../../../utils/createNotification';

export const ApproveEngagementMeetingProposal = createAsyncThunk(
    'engagementMeetings/approveMeetingProposal',
    async (
        {
            engagementId,
            meetingProposalId,
        }: { engagementId: number; meetingProposalId: string },
        { getState }: any
    ) => {
        const axios = getState().core.axios;

        try {
            const response = await axios.post(
                `/api/Marketplace/Engagements/${engagementId}/MeetingScheduling/${meetingProposalId}/Approve`
            );

            if (response.status !== 200 && response.status !== 204) {
                createNotification(
                    'Could not approve meeting proposal at the moment.',
                    'error'
                );
                throw new Error('Failed to approve meeting proposal');
            }

            createNotification(
                'Meeting proposal approved successfully.',
                'success'
            );
            return { engagementId, meetingProposalId };
        } catch (error: any) {
            createNotification(
                'An error occurred while approving the meeting proposal.',
                'error'
            );
            throw error;
        }
    }
);
